import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import filter from 'lodash/filter';
import _keyBy from 'lodash/keyBy';
import _merge from 'lodash/merge';
import _values from 'lodash/values';
import _get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import YDTIcon from 'yoda-core-components/lib/components/Icon';
import CartLarge from 'yoda-core-components/lib/assets/svg/CartLarge.svg';
import CartLine from 'yoda-core-components/lib/assets/svg/CartLine.svg';
import Icon2019JcpenneyLogo from 'yoda-core-components/lib/assets/svg/2019JcpenneyLogo.svg';
import StoreLine from 'yoda-core-components/lib/assets/svg/StoreLine.svg';
import StoreFastTruck from 'yoda-core-components/lib/assets/svg/StoreFastTruck.svg';
import Account from 'yoda-core-components/lib/assets/svg/Account.svg';
import Rewards from 'yoda-core-components/lib/assets/svg/Rewards.svg';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import List from 'yoda-core-components/lib/components/List/List';
import configForList from 'yoda-core-components/lib/components/List/List/List.config';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import LocalStorage, {
    SessionStorage,
} from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import DateFormatter from '../../dates/DateFormatter/DateFormatter';
import { openAccountMenuPage } from '../../actions/SignInSliderActions';
import config from './Header.config';
import * as styles from './Header.css';
import User from '../../helpers/User/User';
import SiteComponent from '../SiteComponent/SiteComponent';
import FetchRegion from '../FetchRegion/FetchRegion';
import FindStoresAction from '../../actions/FindStoresAction';
import analyticsActions from '../../actions/AnalyticsAction';
import orderAction from '../../actions/OrderAction';
import LocationAction from '../../actions/LocationAction';
import vendorAction from '../../actions/OtherVendorAction';
import {
    loadUserStoreLocationInfo,
    updateStoreOnCartAction,
    updateUserStoreLocationInfo,
} from '../../actions/LocationServiceAction';
import itemCountAction from '../../actions/ItemCountAction';
import WeeklyAdsAction from '../../actions/WeeklyAdsAction';
import {
    openSignInSlider,
    getUserDetails,
    accessTimerStart,
    accessTimerAuthCheck,
    showLogoutTooltip,
    customStepUp,
} from '../../actions/AccountAction';
import GalleryRerenderAction from '../../actions/GalleryRerenderAction';
import TopMiniNav from '../TopMiniNav/TopMiniNav';
import ExitPosLazy from '../ExitPos/ExitPosChunksLazy';
import HamburgerPlaceHolder from './HamburgerPlaceHolder';
import storeActions from '../../actions/SetMyDefaultStoreAction';
import KeepMeLoggedInAction from '../../actions/KeepMeLoggedInAction';
import storeNavigationActions from '../../actions/DepartmentVisualNavigationAction';
import SecondaryNavigationPanel from './SecondaryNavigationPanel';
import StickyTimer from '../StickyTimer/StickyTimer';
import ProductSearch from '../ProductSearch/ProductSearch';
import YodaTooltipLazy from '../YodaTooltip/HeaderChunksAndFooterLazy';
import ThirdPartyServiceButton from './ThirdPartyServiceButton';
import { showLazy } from '../../lazy/actions/LazyAction';
import selectLazy from '../../lazy/selectors/selectLazy';
import { selectShouldRender } from '../../selectors/ContextSelector';
import { selectKeepMeLoggedInThrottleFF } from '../../selectors/KeepMeLoggedInSelector';
import HamburgerAction from '../../actions/HamburgerAction';
import Link from '../Link/Link';
import ThrottleFeatureRender from '../ThrottleFeatureRender/ThrottleFeatureRender';
import MobileBotHamburger from '../MobileBotHamburger/MobileBotHamburger';
import productSearchFocusAction from '../../actions/ProductSearchFocusAction';
import YodaTooltip from '../YodaTooltip/YodaTooltip';
import CartWrapper from './CartWrapper';
import CAMNavWrapper from '../CAMNav/CAMNav';
import { fetchVizNavIrisDepartmentData } from './GetNavigationData';
import iovationLoader from '../../helpers/IovationLoader/IovationLoader';
import {
    rewardsPersonalization,
    headerStore,
    findStores,
    locationServiceCookies,
} from '../../common/Constants';
import isCSSFeatureSupported from '../../helpers/Utils/features';
import RewardsInfoOnHover from '../RewardsInfoOnHover/RewardsInfoOnHover';

// Have to remove once the visNav Integration Done
// import mockData from './mockData';
// Have to remove once the visNav Integration Done Ends

const SCROLL_THRESHOLD = 25;
const TIME_THRESHOLD = 300;
const PRIMARY_HEADER_HEIGHT = 56;

const headerLoad = 'headerLoad';
const cx = classNames.bind(styles);

/* istanbul-ignore-next */
export class YodaHeader extends SiteComponent {
    static defaultProps = {
        signedOut: false,
        cartCount: 0,
        headerType: '',
        headerId: 'header',
        deviceType: {},
        accounts: {
            userProfile: {
                firstName: null,
                accountId: null,
                rewardsStatus: null,
                userState: null,
                totalCerts: null,
            },
        },
        bagItemCount: 0,
        actions: {},
        logoLink: 'on',
        shopDepartmentMenuInfo: [],
        primaryLinks: {
            cart: '',
        },
        accountMenuList: {},
        headerLoaded: false,
        desktopAccountMenuList: {},
        featureFlags: {},
        pageName: 'HOME',
        rewardsClass: '',
        trackOrderClass: '',
        searchClass: '',
        headerMainClass: '',
        menuOverlayClass: '',
        showOverlay: false,
        showBgWhite: false,
        inlineOverlay: false,
        shouldRender: true,
        headerConfigs: {},
        activeCartConfig: {},
        toggleWiggleCart: {},
        scrollPreviousValue: 0,
        productSearchFocus: '',
        locationServiceStoreInfo: {},
        weeklyAdsMessages: [],
        rewardsHoverInfoMessagesTexts: {},
        isFragment: false,
        pdpProductOffering: {},
        checkoutProps: {},
        findStoresDetails: {},
        HamburgerSlider: {},
    };

    static propTypes = {
        headerType: PropTypes.string.isRequired,
        headerId: PropTypes.string,
        accounts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        deviceType: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        bagItemCount: PropTypes.number,
        actions: PropTypes.object,
        logoLink: PropTypes.string,
        shopDepartmentMenuInfo: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        accountMenuList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        desktopAccountMenuList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        headerLoaded: PropTypes.bool,
        pageName: PropTypes.string.isRequired,
        rewardsClass: PropTypes.string,
        trackOrderClass: PropTypes.string,
        searchClass: PropTypes.string,
        headerMainClass: PropTypes.string,
        menuOverlayClass: PropTypes.string,
        showOverlay: PropTypes.bool,
        showBgWhite: PropTypes.bool,
        inlineOverlay: PropTypes.bool,
        shouldRender: PropTypes.bool,
        headerConfigs: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        activeCartConfig: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        toggleWiggleCart: PropTypes.object,
        enableKeepMeLoggedIn: PropTypes.bool.isRequired,
        scrollPreviousValue: PropTypes.number,
        productSearchFocus: PropTypes.string,
        locationServiceStoreInfo: PropTypes.object,
        weeklyAdsMessages: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        rerenderGallery: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        rewardsHoverInfoMessagesTexts: PropTypes.objectOf(PropTypes.any),
        isFragment: PropTypes.bool,
        pdpProductOffering: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        checkoutProps: PropTypes.object,
        findStoresDetails: PropTypes.object,
        HamburgerSlider: PropTypes.object,
    };

    static signinLink = '/signin';

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.getHeaderTheme = this.getHeaderTheme.bind(this);
        this.renderMenuList = this.renderMenuList.bind(this);
        this.menuListClickOption = this.menuListClickOption.bind(this);
        this.isLoggedIn = 1;
        this.state = {
            cartCount: this.props.bagItemCount,
            signedOutActive: false,
            resetMenu: false,
            isUserLoggedIn: null,
            showLoader: false,
            showsignInReminder: this.showsignInReminder(),
            wiggleCart: false,
            headerScroll: 'mainHeaderScroll',
            displayHover: false,
            isListClicked: false,
            weeklyAdsMessages: [],
            akamaiStoreInfo: {},
        };
        this.signInClick = this.openSignInSlider.bind(this, false, null, false);
        this.headerAccountMenuClickHandler = this.headerAccountMenuClickHandler.bind(this);
        this.createAccountClick = this.openSignInSlider.bind(this, true, null, false);
        this.authCheckForExpiry = this.authCheckForExpiry.bind(this);
        this.handleNavListCallBack = this.handleNavListCallBack.bind(this);
        this.akGeoCookie = Cookies.load('ak_geo') || false;
        this.akamaiStoreCookie = Cookies.load('akamaiStore');
        this.akamaiStoreCookieInfo = this.akamaiStoreCookie
            ? Utils.parseJson(this.akamaiStoreCookie)
            : {};
        // isWeeklyAdsInvoked: used to invoke weekly Ads Api once when ak_geo not present or geo location storeId present
        this.isWeeklyAdsInvoked = false;
        this.weeklyAdsDefaultImg = _get(
            this.props,
            'preferences.headerStoreHoverConfig.weeklyAdsDefaultImg',
            ''
        );
        this.findAStoreLink = _get(
            this.props,
            'preferences.headerStoreHoverConfig.findAStoreLink',
            'https://www.jcpenney.com/findastore'
        );
        this.sameDayPickupLink = _get(
            this.props,
            'preferences.headerStoreHoverConfig.sameDayPickupLink',
            'https://www.jcpenney.com/m/same-day-pickup'
        );
        this.displaySDPU = _get(
            this.props,
            'preferences.headerStoreHoverConfig.displaySDPU',
            false
        );
        this.storeInfo = _get(this.props, 'preferences.headerStoreHoverConfig.storeInfo', '');
        this.viewMoreAdsLink = _get(
            this.props,
            'preferences.headerStoreHoverConfig.viewMoreAdsLink',
            'https://www.jcpenney.com/m/digital-books?pageId=pg40030000010'
        );

        // these are related to scroll functionality for sticky header
        this.scrollPreviousValue = 0;
        this.timestamp = new Date();
        this.onSrollTriggerEvents = this.onSrollTriggerEvents.bind(this);
        this.isScrollThresholdMet = this.isScrollThresholdMet.bind(this);
        this.scrollHandler = this.scrollHandler.bind(this);

        this.headerOverlayRef = React.createRef();
    }

    componentDidMount() {
        this.props.actions.showLazy(headerLoad);
        this.props.actions.accessTimerStart();
        this.authCheckForExpiry();
        this.setGeoZipCode();
        if (this.state.showsignInReminder) {
            const toolTipTimeout = _get(
                this.props.preferences,
                'signInSliderWelcomeMessageTimeOut',
                3000
            );
            /* istanbul ignore next */
            setTimeout(() => {
                /* istanbul ignore next */
                this.setState({
                    showsignInReminder: false,
                });
            }, toolTipTimeout);
        }
        const {
            featureFlags: {
                enableVendorActionCallBack,
                enableIovationEagerLoading,
                disableStickyHeader,
            },
            preferences: {
                devicefingerPrintConfig: iovationConfig,
                deviceFingerPrintIovation: iovationSrc,
            },
            actions: { onIovationScriptLoadError, onIovationScriptLoadSuccess },
            deviceType: { isTablet },
            enableKeepMeLoggedIn,
        } = this.props;
        /* istanbul ignore next */
        if (enableKeepMeLoggedIn && !enableIovationEagerLoading) {
            iovationLoader(
                iovationSrc,
                iovationConfig,
                onIovationScriptLoadError,
                onIovationScriptLoadSuccess
            );
        }
        if (enableVendorActionCallBack) {
            /* istanbul ignore next */
            window.handleVendorAction = (actionType, payload, callback) => {
                if (actionType === 'apply_coupon' && payload.couponCode) {
                    this.props.actions.applyOtherCoupon(
                        {
                            code: payload.couponCode,
                            serialNumber: payload.serialCode,
                        },
                        callback
                    );
                }
            };
        }

        /* istanbul ignore next */
        if (
            !disableStickyHeader &&
            isCSSFeatureSupported(
                '(position: sticky) or (position: -webkit-sticky) or (position: -ms-sticky)'
            ) &&
            !isTablet
        ) {
            window.addEventListener('scroll', this.onSrollTriggerEvents);
        }
    }

    componentDidUpdate() {
        const {
            isFragment = false,
            actions: { loadUserStoreLocationInfo },
            featureFlags: { useOldCommonBopisService = false },
        } = this.props;
        const { storeName = '' } = this.getPreferredStore();
        const shouldLoadLocationInfo = !storeName && isFragment && !useOldCommonBopisService;
        // loadUserStoreLocationInfo to be called on syndicate sites as the cookie value is stored by browser a bit delayed.
        shouldLoadLocationInfo && loadUserStoreLocationInfo();
    }

    onSrollTriggerEvents() {
        /* istanbul ignore else */
        if (!this.scrollTicking) {
            /* istanbul ignore next */
            window.requestAnimationFrame(() => {
                this.scrollTicking = true;
                const scrollY = window.scrollY || window.pageYOffset;
                let { headerScroll } = this.state;
                const {
                    deviceType: { isDesktop, isMobile },
                } = this.props;
                if (
                    isMobile
                        ? scrollY > this.scrollPreviousValue &&
                          !(
                              this.scrollPreviousValue === 0 &&
                              scrollY > 0 &&
                              headerScroll !== 'headerScrollDown'
                          )
                        : scrollY > this.scrollPreviousValue
                ) {
                    // scroll down
                    if (scrollY > PRIMARY_HEADER_HEIGHT) {
                        if (!isDesktop) {
                            headerScroll = 'headerScrollDown';
                        } else {
                            headerScroll = null;
                        }
                    }
                    this.scrollHandler({ scrollY, headerScroll });
                } else {
                    // scroll up
                    // remove sticky class for desktop when reaches close to primary header height
                    if (isDesktop && scrollY < PRIMARY_HEADER_HEIGHT) {
                        this.scrollHandler({ scrollY, headerScroll: null });
                    } else if (isMobile && scrollY === 0) {
                        this.scrollHandler({ scrollY, headerScroll });
                    } else {
                        headerScroll = 'headerScrollUp';
                        isMobile && this.scrollHandler({ scrollY, headerScroll });
                    }
                    headerScroll = 'headerScrollUp';
                    !isMobile && this.scrollHandler({ scrollY, headerScroll });
                }
                this.scrollPreviousValue = scrollY;
                this.scrollTicking = false;
            });
        }
    }

    scrollHandler({ scrollY, headerScroll }) {
        const {
            galleryRerender,
            actions: { galleryRerenderAction },
            deviceType: { isMobile },
        } = this.props;
        /* istanbul ignore next */
        if (galleryRerender) {
            let scrollClass = null;
            if (isMobile) {
                scrollClass = 'headerScrollUp';
            }
            this.setState({ headerScroll: scrollClass }, () => {
                this.scrollPreviousValue = scrollY;
                this.timestamp = +new Date();
            });
            galleryRerenderAction(false);
            return;
        }
        /* istanbul ignore next */
        if (this.state.headerScroll !== headerScroll && this.isScrollThresholdMet(scrollY)) {
            this.setState({ headerScroll }, () => {
                this.scrollPreviousValue = scrollY;
                this.timestamp = +new Date();
            });
        }
    }

    isScrollThresholdMet(scrollY = 0) {
        const scrollDifference = Math.abs(this.scrollPreviousValue - scrollY);
        const timestampDifference = new Date() - this.timestamp;
        return scrollDifference > SCROLL_THRESHOLD && timestampDifference > TIME_THRESHOLD;
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onSrollTriggerEvents);
    }

    /* ugly code need to redo in r2 */
    shouldComponentUpdate(nextProps, nextState) {
        if (isEqual(nextProps, this.props) && isEqual(nextState, this.state)) {
            return false;
        }
        return true;
    }

    componentWillReceiveProps(nextProps) {
        // this.setState({ cartCount: Cookies.load('ItemCount') });
        this.setState({ cartCount: nextProps.bagItemCount });
        this.getUserStateDetails(nextProps);
        if (nextProps.accounts.userProfile) {
            this.setState({
                showLoader: false,
            });
        } else {
            this.setState({
                showLoader: true,
            });
        }
        const {
            featureFlags: { useOldCommonBopisService = false },
        } = this.props;
        const isUserLoggedIn = _get(this.props.accounts, 'userProfile.userState', '0') !== '0';
        const isUserLoggedInNextProps =
            _get(nextProps.accounts, 'userProfile.userState', '0') !== '0';
        const userPreferredStore = this.getPreferredStore();
        const locationServiceStoreId = _get(userPreferredStore, 'storeId', null);
        const { address = '' } = userPreferredStore;
        if (!useOldCommonBopisService && !isEmpty(address)) {
            this.props.actions.updateUserStoreLocationInfo({
                curbsidePickupIndicator: userPreferredStore.curbsidePickupIndicator || false,
                distance: userPreferredStore.distance || '',
                id: userPreferredStore.storeId || '',
                inputZipCode: userPreferredStore.inputZipCode || '',
                name: userPreferredStore.storeName || '',
                phone: userPreferredStore.phone || '',
                zip: userPreferredStore.zipcode || '',
                street: userPreferredStore.street || '',
                city: userPreferredStore.city || '',
                state: userPreferredStore.state || '',
                timings: userPreferredStore.timings || '',
                timingsOverrideMessage: userPreferredStore.timingsOverrideMessage || '',
            });
        }
        // To update store details in cart when a user gets logged in
        if (
            !isEmpty(this.props.accounts) &&
            !isUserLoggedIn &&
            isUserLoggedInNextProps &&
            !useOldCommonBopisService
        ) {
            if (locationServiceStoreId) {
                this.props.actions.updateStoreOnCartAction &&
                    this.props.actions.updateStoreOnCartAction(locationServiceStoreId);
            } else {
                this.getStoreDetails(true);
            }
        }
        const geoStoreID = _get(nextProps, 'locationServiceStoreInfo.storeId');
        const { deviceType, featureFlags } = this.props;
        /* istanbul ignore next */
        if (
            (deviceType.isDesktop &&
                featureFlags.enableHeaderStoreMenuSlider &&
                !this.isWeeklyAdsInvoked &&
                geoStoreID) ||
            !this.akGeoCookie
        ) {
            // default store code/id for weekly ads to fetch referred from Marketing page which is Manhattan Mall (store id = 0174)
            const DEFAULT_WEEKLY_ADS_STORE_CODE = '0174';
            const weeklyAdsStoreCode = {
                storeCode: geoStoreID || DEFAULT_WEEKLY_ADS_STORE_CODE,
            };
            this.isWeeklyAdsInvoked = true;
            this.akGeoCookie = true;
            this.props.actions.getWeeklyAdDetails(weeklyAdsStoreCode);
        }

        if (!isEqual(nextProps.weeklyAdsMessages, this.props.weeklyAdsMessages)) {
            this.setState({ weeklyAdsMessages: nextProps.weeklyAdsMessages });
        }

        const pageUrl = window && window.location.href;
        if (!useOldCommonBopisService && pageUrl && this.isGalleryPage(pageUrl)) {
            const urlStoreId = Utils.getURLParameterBykey('storeIds', pageUrl);
            if (
                !isEmpty(locationServiceStoreId) &&
                !isEmpty(urlStoreId) &&
                urlStoreId !== locationServiceStoreId
            ) {
                const isSDPUEnabled = Utils.getURLParameterBykey('store_availability', pageUrl);
                if (
                    !__SERVER__ &&
                    !document.getElementById('storeGalleryBopisFilter') &&
                    isSDPUEnabled
                ) {
                    const updatedUrl = new URL(pageUrl);
                    updatedUrl.searchParams.set('storeIds', locationServiceStoreId);
                    history.pushState({}, '', updatedUrl);
                }
            }
        }
    }

    showsignInReminder() {
        let showTooltip = false;
        let isSuccess = false;
        const { featureFlags, deviceType, pageName } = this.props;
        if (
            !__SERVER__ &&
            featureFlags.enableSessionToolTip &&
            deviceType.isDesktop &&
            pageName === 'HOME'
        ) {
            const isSessionActive = LocalStorage.getData('activeSession', true);
            /* istanbul ignore else */
            if (!isSessionActive) {
                showTooltip = true;
                isSuccess = LocalStorage.setData('activeSession', true, true, '', false, 1440);
            }
        }
        return showTooltip && isSuccess;
    }

    getUserStateDetails(nextProps) {
        const getProps = nextProps || this.props;
        const isUserLoggedIn =
            (_get(getProps.accounts, 'userProfile.userState', '0') || '0') !== '0';
        this.setState({
            isUserLoggedIn,
        });
    }

    headerAccountMenuClickHandler() {
        // user_state HOT or WARM (loggedIn): display account nav
        // user_state COLD: display signin slider
        const { isUserLoggedIn } = this.state;
        if (isUserLoggedIn) {
            this.props.actions.openAccountMenuPage();
        } else {
            this.signInClick();
        }
    }

    openSignInSlider(isCreateAccount = false, nextUrl, isLogout = false) {
        const { featureFlags } = this.props;
        const isHideAccountMenu = _get(featureFlags, 'isHideAccountMenuSlider', false);
        const customizeConfig = {
            forceLogin: true,
            skipOnAuthenticationSuccess: true,
            isHideAccountMenu: true,
            postAuthenticationUrl: nextUrl,
            isSliderCustomized: true,
            openCreateAccount: isCreateAccount,
        };
        if (featureFlags.enableSignInSlider) {
            if (!isLogout) {
                isHideAccountMenu
                    ? this.props.actions.customStepUp(customizeConfig)
                    : this.props.actions.openSignInSlider(isCreateAccount, nextUrl, isLogout);
            } else {
                this.props.actions.showLogoutTooltip();
            }
            // Tell link component to not redirect
            return false;
        }
        if (isCreateAccount) {
            return '/createaccount'; // redirect through Link component to /createaccount
        }
        if (isLogout) {
            return '/sessiontimeout'; // redirect through Link component to /sessiontimeout
        }
        return '/signin'; // redirect through Link component to /signin
    }

    authCheckForExpiry() {
        /* istanbul ignore if */
        if (TokenProvider.get('DP_USER_STATE') === '1') {
            if (TokenProvider.get('DP_FULL_ACCESS_EXPIRED') === 'true') {
                this.props.actions.accessTimerAuthCheck();
            }
            setTimeout(() => {
                this.authCheckForExpiry();
            }, 20 * 1000);
        }
    }

    // hpan start
    getHeaderTheme = () => {
        let theme = 'fullHeader';
        if (this.props.headerType === config.headerTypes.MINIMAL_HEADER) {
            theme = 'minimalHeader';
        } else if (this.props.headerType === config.headerTypes.SLIM_HEADER) {
            theme = 'slimHeader';
        }
        return theme;
    };

    handleWrapperClick(event) {
        event.stopPropagation();
    }

    handleNavListCallBack(value) {
        this.setState({ isListClicked: value });
    }

    /* istanbul ignore next */
    searchSelectAnimationRemove = () => {
        if (this.state.headerScroll !== 'headerScrollUp') {
            this.setState({ headerScroll: 'headerScrollUp' });
        }
    };

    renderRewardsInfoInAccountHover = () => {
        const {
            accounts,
            featureFlags: { showRewardsInHeader = false },
        } = this.props;
        const userName =
            _get(accounts, 'userProfile.firstName', '') || config.accountInfo.myAccountLabel;
        const rewardsDetails = TokenProvider.get('DP_REWARDS_DETAILS') || {};
        return showRewardsInHeader ? (
            <RewardsInfoOnHover userName={userName} rewardsDetails={rewardsDetails} />
        ) : null;
    };

    renderHoverTooltipData = () => {
        const {
            preferences: { hoverAccountMenuNav },
            accounts,
        } = this.props;
        const { isUserLoggedIn, isListClicked } = this.state;
        const totalCerts = _get(accounts, 'userProfile.totalCerts', 0);
        /* istanbul ignore next */
        isListClicked && this.setState({ isListClicked: false });
        let accountIconWidth = '80px';
        if (this.accountIcon) {
            const position = this.accountIcon.getBoundingClientRect();
            accountIconWidth = position.width;
        }
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        return (
            <div
                className={
                    /* istanbul ignore next */
                    cx('listWrapper', isUserLoggedIn && 'accountLoggedIn')
                }
                onClick={this.handleWrapperClick}
            >
                {!isUserLoggedIn && (
                    <>
                        <Link
                            type="Button"
                            onClick={this.signInClick}
                            data-automation-id="account-signin"
                            buttonType="Primary"
                            className={cx('hoverButton')}
                        >
                            Sign In
                        </Link>
                        <Link
                            type="Button"
                            buttonType="Secondary"
                            data-automation-id="account-create-account"
                            onClick={this.createAccountClick}
                            className={cx('hoverButton', 'createAccountButton')}
                        >
                            Create Account
                        </Link>
                    </>
                )}
                {
                    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                    <div
                        className={cx('hoverAction')}
                        onClick={this.headerAccountMenuClickHandler}
                        style={{ width: accountIconWidth }}
                    />
                }
                {isUserLoggedIn && this.renderRewardsInfoInAccountHover()}
                <CAMNavWrapper
                    navConfig={hoverAccountMenuNav}
                    classes={{
                        navContainer: 'headerAccountMenu',
                        hoverContainer: 'hoverAccountWrapper',
                    }}
                    highlightActiveItem={false}
                    navListCallBack={this.handleNavListCallBack}
                    rewardsSpend={totalCerts}
                />
            </div>
        );
    };

    /* istanbul ignore next */
    toggleHoverFilters = () => {
        this.setState({
            displayHover: !this.state.displayHover,
        });
    };

    /* istanbul ignore next */
    getTrackMyOrder = () => {
        const trackMyOrderPref = this.props.preferences.trackMyOrder || {};
        const userSigninState = User.isUserLoggedIn() ? 'signedin' : 'guest';
        const getTrackOrderLink = () => {
            this.isLoggedIn = User.isUserLoggedIn();
            return this.isLoggedIn ? trackMyOrderPref[userSigninState] : '/orders/trackorders';
        };
        const href = __SERVER__ ? '/orders/trackorders' : getTrackOrderLink();

        const link = (
            <Link
                href={href}
                className={cx('trackMyOrderLink')}
                id="headerTrackMyOrder"
                title="track my orders"
                data-automation-id="trackMyOrderLink"
                onClick={() => {
                    this.props.actions.triggerNavigationClick({
                        linkName: 'top:track my order',
                        isReload: false,
                    });
                    return true; // redirect through Link component to href
                }}
            >
                <div className={cx('trackMy')}>Track My</div>
                <div className={cx('orders')}>Orders</div>
            </Link>
        );
        return __SERVER__ ? <span>{link}</span> : <div>{link}</div>;
    };

    // render rewards icon
    getRewardsIcon = () => {
        const getRewardLink = () => {
            this.isLoggedIn = User.isUserLoggedIn();
            /* istanbul ignore next */
            return !this.isLoggedIn ? '/rewards' : '/rewards/rewards/dashboard';
        };

        /* istanbul ignore next */
        const rewardLink = __SERVER__ ? '/rewards' : getRewardLink();

        const link = (
            <Link
                href={rewardLink}
                className={cx('rewardsIconLink')}
                id="headerRewards"
                title="my rewards"
                data-automation-id="rewardsLink"
            >
                <Icon
                    iconType="svg"
                    className={cx('rewardsIcon')}
                    width="80px"
                    height="40px"
                    viewBox="-5 -5 110 48"
                >
                    <Rewards />
                </Icon>
            </Link>
        );
        /* istanbul ignore next */
        return __SERVER__ ? <span>{link}</span> : <div>{link}</div>;
    };

    // render logo
    getLogo = () => {
        // adding hyperlink only for TOF pages
        const logoLink = this.props.logoLink === 'on' ? '/' : '';
        const { deviceType, featureFlags, preferences } = this.props;
        let iconWidth = '';
        let iconHeight = '';
        let viewBoxValue = '';
        const logoName = _get(preferences, 'assets.logoName', '2019-jcpenney-logo');
        const logoComponent = _get(preferences, 'assets.logoComponent', <Icon2019JcpenneyLogo />);
        const enableNewLogo = _get(featureFlags, 'enableNewLogo', true);
        /* istanbul ignore next */
        if (featureFlags.enableHamburgerMenuLabel && deviceType.isTablet) {
            iconWidth = '120px';
            iconHeight = enableNewLogo ? '38px' : '28px';
            viewBoxValue = '0 0 120 28';
        } else if (featureFlags.enableHamburgerMenuLabel && deviceType.isMobile) {
            if (enableNewLogo) {
                iconWidth = '110px';
                iconHeight = '34px';
                viewBoxValue = '0 0 110 34';
            } else {
                iconWidth = '103px';
                iconHeight = '24px';
                viewBoxValue = '0 0 103 24';
            }
        } else if (enableNewLogo) {
            iconWidth = '165px';
            iconHeight = '43px';
            viewBoxValue = '0 0 165 43';
        } else {
            iconWidth = '130px';
            iconHeight = '34px';
            viewBoxValue = '0 0 130 34';
        }

        return (
            <Link
                href={logoLink}
                className={cx('logoLink')}
                data-automation-id="jcp-logo"
                title="JCPenney Home"
                id="jcp-logo"
                aria-label="Jcpenney logo navigate to home"
            >
                <Icon
                    iconType="svg"
                    width={iconWidth}
                    height={iconHeight}
                    viewBox={viewBoxValue}
                    className={cx('jcpLogo')}
                >
                    {logoComponent}
                </Icon>
            </Link>
        );
    };

    getCartLink = () => this.props.primaryLinks.cart;

    getGlobalNavParams = () => ({ pageType: this.props.pageName });

    // getPromotionalBannerScrollFlag = () => {
    //     const scrollYPosition = window.scrollY || window.pageYOffset;
    //     const promoBannerScrollFlag = scrollYPosition === 0;
    //     return promoBannerScrollFlag;
    // }

    hydrateOnMount() {
        const globalNavParams = this.getGlobalNavParams();

        if (!__SERVER__) {
            this.props.actions.getUserDetails();
            /* istanbul ignore else */
            if (!this.props.preferences.storeCallNotNeededOnPageLoad) {
                this.props.actions.setMyDefaultStore();
            }
            this.setState({ showLoader: true });
            this.props.actions.updateItemCountAction();

            // Client side rendering for IRIS Global Nav APIs
            if (
                this.props.deviceType.isDesktop &&
                this.props.featureFlags &&
                !this.props.featureFlags.disableVisualNavSSR
            ) {
                this.props.actions.getIrisGlobalNavigationAction(globalNavParams);
            }

            if (this.props.featureFlags && this.props.featureFlags.enableHybridHamburger) {
                // on mount go fetch department list for hybrid hamburger
                this.props.actions.getIrisCategories(globalNavParams);
            }
        }

        if (__SERVER__) {
            /* istanbul ignore next */
            const {
                deviceType: { isDesktop, isBot },
                featureFlags: { enableRenderBotDept = false },
            } = this.props;
            // Server side rendering for IRIS Global Nav APIs ONLY FOR BOT
            /* istanbul ignore else */
            if (isDesktop && isBot && enableRenderBotDept) {
                this.props.actions.getIrisGlobalNavigationAction(globalNavParams);
            }
        }
        // Update the store details if cookie is available.
        this.getStoreDetails();
    }

    showRewardsInfoInHeader = (accountState) => {
        const {
            MY_ACCOUNT,
            REWARDS_MEMBER,
            DP_REWARDS_DETAILS,
            REWARD_AVAILABLE,
            POINTS,
        } = rewardsPersonalization;
        const { accounts: { userProfile = {} } = {} } = this.props;
        const { firstName = '', userState = '0' } = userProfile || {};
        const isRegisteredUser = userState === '1' || userState === '2';
        const getRewardDetailsFromLocalStorage = TokenProvider.get(DP_REWARDS_DETAILS) || {};
        const {
            points: { pointsThreshold = 200, earnedPoints = 0 } = {},
            certificates: { numberOfCerts = 0, totalCertsValue = 0 } = {},
        } = getRewardDetailsFromLocalStorage;
        const handleRewardsInfo =
            numberOfCerts === 0 && totalCertsValue === 0
                ? earnedPoints >= 50
                    ? `${earnedPoints} / ${pointsThreshold} ${POINTS}`
                    : REWARDS_MEMBER
                : `$${totalCertsValue} ${REWARD_AVAILABLE}`;
        const userFirstName = startCase(toLower(firstName));
        return (
            <div className={cx('flex', 'flex-col', 'pl-half', 'text-left', 'mb-half')}>
                <p
                    data-automation-id="acc-user-name"
                    data-cs-mask="true"
                    className={cx('font-open-sans-semibold', 'text-small', 'text-gray-600')}
                >
                    {isRegisteredUser ? userFirstName : MY_ACCOUNT}
                </p>
                <p
                    data-automation-id="acc-info-state"
                    className={cx('text-xsmall', 'text-gray-600')}
                >
                    {isRegisteredUser ? handleRewardsInfo : accountState}
                </p>
            </div>
        );
    };

    /* Render account icon for signin and my account */
    renderAccountIcon = (accountState) => {
        const {
            showWelcomeToolTip,
            featureFlags: { showRewardsInHeader = false },
            deviceType: { isMobile = true },
        } = this.props;
        let showAccountIcon = 'ctaList accountBlock';
        if (showRewardsInHeader) {
            showAccountIcon = 'flex flex-row mt-1';
        }
        return (
            <div
                className={cx('svg-icon', showAccountIcon)}
                data-automation-id="header_account_block"
            >
                <Icon
                    iconType="svg"
                    automationId="account-icon"
                    className={cx('svg-icon')}
                    width="40px"
                    height="40px"
                    viewBox="0 0 40 40"
                    pathClassName={cx('accountFillColor')}
                >
                    <Account />
                </Icon>
                {showWelcomeToolTip && (
                    <div className={cx('welcomeToolTip')}>
                        <span
                            data-automation-id="user-name-cached"
                            className={cx('welcomeToolTipText')}
                        >
                            You're Signed Out
                        </span>
                    </div>
                )}
                {showRewardsInHeader && !isMobile ? (
                    this.showRewardsInfoInHeader(accountState)
                ) : (
                    <h4 data-automation-id="acc-info-state" className={cx('menuText')}>
                        {accountState}
                    </h4>
                )}
            </div>
        );
    };

    /* Render account information like  user name and myaccount */
    renderAccountData = (accountState = config.accountInfo.signInLabel) => {
        const { isUserLoggedIn, showsignInReminder, isListClicked } = this.state;
        const {
            featureFlags: { showRewardsInHeader },
        } = this.props;

        return (
            <>
                <ThrottleFeatureRender
                    featurePath="enableHeaderHoverMenu"
                    headerName="X-ENABLE-HEADER-HOVER-MENU"
                    cookieName="DP_ENABLE_HEADER_HOVER_MENU"
                >
                    {
                        /* istanbul ignore next */
                        (isEnabled) => (
                            <>
                                {isEnabled ? (
                                    <YodaTooltip
                                        tooltipContentClass={cx('accountTooltipContent', {
                                            newPersonalisedAccount: showRewardsInHeader,
                                        })}
                                        tooltipBodyClassName={cx(
                                            'accountHoverTooltip',
                                            isUserLoggedIn && 'loggedIn'
                                        )}
                                        renderTooltipContents={this.renderHoverTooltipData()}
                                        triggerEventName="mouseover"
                                        stayOnContentHover
                                        isListClicked={isListClicked}
                                        isAccountHover
                                        callBackFun={this.toggleHoverFilters}
                                    >
                                        {this.renderAccountIcon(accountState)}
                                    </YodaTooltip>
                                ) : (
                                    this.renderAccountIcon(accountState)
                                )}
                            </>
                        )
                    }
                </ThrottleFeatureRender>
                {
                    /* istanbul ignore next */
                    showsignInReminder && !isUserLoggedIn && (
                        <div
                            data-automation-id="default-account-username"
                            className={cx('welcomeToolTip')}
                        >
                            <span
                                data-automation-id="user-name-cached"
                                className={cx('welcomeToolTipText', 'welcomeGuestToolTip')}
                            >
                                <span className={cx('startEarningRewards')}>
                                    Start Earning Rewards!
                                </span>
                                <>
                                    <Link
                                        type="Button"
                                        onClick={this.signInClick}
                                        automationId="account-signin"
                                        buttonType="Primary"
                                        className={cx('sigInButton', 'welcomeSignInBtn')}
                                    >
                                        Sign In
                                    </Link>
                                    <Link
                                        type="button"
                                        data-automation-id="acc-signup-register-btn"
                                        onClick={this.createAccountClick}
                                    >
                                        <a
                                            data-automation-id="acc-signup-register-anchor"
                                            className={cx('registerLink')}
                                        >
                                            {' '}
                                            {'create account'}{' '}
                                        </a>
                                    </Link>
                                </>
                            </span>
                        </div>
                    )
                }
            </>
        );
    };

    renderAccoundInformation = () => {
        const { isUserLoggedIn } = this.state;

        if (isUserLoggedIn) {
            const myAccountLabel =
                _get(this.props, 'accounts.userProfile.firstName', '') ||
                config.accountInfo.myAccountLabel;
            return this.renderAccountData(myAccountLabel);
        }
        return this.renderAccountData();
    };

    renderTooltipData() {
        return this.state.showLoader ? (
            <Loader automationId="account-loader" />
        ) : (
            this.renderAccountTooltipData()
        );
    }

    prepareMenuList(attribute = 'guest') {
        let accountMenuList = this.props.accountMenuList[attribute];
        if (this.props.deviceType.isDesktop) {
            const desktopAccountMenuList = this.props.desktopAccountMenuList[attribute] || [];
            const destMenu = _keyBy(accountMenuList, 'name');
            const srcMenu = _keyBy(desktopAccountMenuList, 'name');
            accountMenuList = _values(_merge({}, destMenu, srcMenu));
        }
        return filter(accountMenuList, (item) => item.isDisplayRequiredInAccountMenu);
    }

    renderAccountTooltipData() {
        const { isUserLoggedIn } = this.state;
        const totalCerts = _get(this.props.accounts, 'userProfile.totalCerts', 0);

        let source;
        let styleClass;
        let showButtonANdLink = false;
        const rewardsStatus = _get(this.props.accounts, 'userProfile.rewardsStatus');
        const rewardsCount = rewardsStatus ? totalCerts : 0;

        if (isUserLoggedIn) {
            source = this.prepareMenuList('signedin');
            styleClass = totalCerts || totalCerts === 0 ? 'signedInWithCerts' : 'signedInUser';
        } else {
            source = this.prepareMenuList('guest');
            styleClass = 'signedOutUser';
            showButtonANdLink = true;
        }
        return (
            <div data-automation-id="headerAccountTooltip" id="headerAccount">
                {showButtonANdLink ? (
                    <>
                        <Link
                            type="Button"
                            onClick={this.signInClick}
                            automationId="account-signin"
                            buttonType="Primary"
                            size="Lg"
                            className={cx('sigInButton')}
                        >
                            Sign In
                        </Link>
                        <span data-automation-id="acc-signup-text" className={cx('newCustomer')}>
                            {'New Customer? '}
                        </span>
                        <Link
                            type="button"
                            data-automation-id="acc-signup-register-btn"
                            onClick={this.createAccountClick}
                        >
                            <a
                                data-automation-id="acc-signup-register-anchor"
                                className={cx('registerLink')}
                            >
                                {' '}
                                {'Register Here'}{' '}
                            </a>
                        </Link>
                    </>
                ) : null}
                <List
                    datasource={source}
                    direction="Vertical"
                    listBodyClass={cx('list-class')}
                    listStyleClass={cx('list-ul-class')}
                    itemStyleClass={cx('list-item-class', styleClass)}
                    childRenderer={this.renderMenuList}
                    spacing="None"
                    automationId="at-error-helpfullinks-renderer"
                />
                {totalCerts ? (
                    <Button
                        type="button"
                        automationId="rewards-redeem"
                        buttonType="Primary"
                        size="Lg"
                        className={cx('redeemText')}
                    >
                        <span
                            data-automation-id="acc-info-rewards-block"
                            className={cx('redeemCertsWrapper')}
                        >
                            <span data-automation-id="rewardsAmount" className={cx('dollerValue')}>
                                $
                            </span>
                            <span data-automation-id="rewards-count">{`${rewardsCount}`}</span>
                        </span>
                        Redeem Your Rewards
                    </Button>
                ) : null}
            </div>
        );
    }

    menuListClickOption = (nextUrl) => {
        const { featureFlags } = this.props;
        /* istanbul ignore next */
        if (!__SERVER__) {
            if (featureFlags.enableSignInSlider) {
                if (featureFlags.enableLogoutSlider && nextUrl === '/sessiontimeout') {
                    return this.openSignInSlider(false, undefined, true);
                }
                if (nextUrl === '/sessiontimeout') {
                    return nextUrl;
                }
                if (LocalStorage.getData('DP_USER_STATE') === '1') {
                    return true; // redirect through Link component
                }
                return this.openSignInSlider(false, nextUrl);
            }
            return nextUrl; // redirect through Link component
        }
        /* istanbul ignore next */
        return false; // tell Link component not to redirect
    };

    renderMenuList = (item) => {
        const rewardsCount =
            this.props.accounts &&
            this.props.accounts.userProfile &&
            this.props.accounts.userProfile.rewardsStatus
                ? this.props.accounts.userProfile.totalCerts
                : 0;
        /* const savedItemCount = this.props.account &&
                                this.pros.accounts.userProfile ?
                                this.props.accounts.userProfile.savedItemsCount : 0; */
        const linksForLabels = item.link;
        const sliderNeeded = item.isSliderNeeded || false;

        const totalCerts =
            this.props.accounts &&
            this.props.accounts.userProfile &&
            this.props.accounts.userProfile.totalCerts &&
            this.props.accounts.userProfile.totalCerts !== '0'
                ? this.props.accounts.userProfile.totalCerts
                : '';

        if (sliderNeeded) {
            return (
                <Link
                    type="button"
                    className={cx('links')}
                    onClick={() => this.menuListClickOption(linksForLabels)}
                >
                    {item.name}
                    {totalCerts && item.displayCount === 'rewards' && (
                        <span className={cx('rewardscount')}>{`(${rewardsCount})`}</span>
                    )}
                </Link>
            );
        }

        return (
            <Link href={linksForLabels} className={cx('links')} data-automation-id="item-name">
                {item.name}
                {totalCerts && item.displayCount === 'rewards' && (
                    <span
                        data-automation-id="rewards-count"
                        className={cx('rewardscount')}
                    >{`(${rewardsCount})`}</span>
                )}
            </Link>
        );

        /* {(totalCerts && item.displayCount === 'savedItems') && <span className={cx('rewardscount')}>{`(${savedItemCount})`}</span>} */
    };

    // below method formates day & time from the timing object from API
    /* istanbul ignore next */
    storeTimingsRenderer = (timing) => {
        const storeTime = _get(timing, 'time', '');
        const storeOpenDay = _get(timing, 'days', '');

        let time = storeTime.replace(/:00/g, '');
        time = time.replace(/-/g, ' - ');

        const days = storeOpenDay.replace(/-/g, ' - ');
        return `${days}: ${time}`;
    };

    /**
     * Accepts a date string as params and returns true if its valid Ads
     */
    /* istanbul ignore next */
    isValidWeeklyAd = (startDate, endDate) => {
        const startTime = new Date(startDate).getTime();
        const endTime = new Date(endDate).getTime();
        const sysTime = new Date().getTime();
        return endTime - sysTime > 0 && sysTime - startTime > 0;
    };

    /* istanbul ignore next */
    toggleHoverStores = () => {
        if (this.akamaiStoreCookieInfo !== this.state.akamaiStoreInfo) {
            this.setState({ akamaiStoreInfo: this.akamaiStoreCookieInfo });
        }
    };

    /* istanbul ignore next */
    displayWeeklyAds = () => {
        const { weeklyAdsMessages } = this.state;
        let weeklyAdsData = [];
        const weeklyAdsMsgLength = weeklyAdsMessages.length;
        /* istanbul ignore else */
        if (!weeklyAdsMsgLength) {
            return false;
        }
        const viewAllAdsLink = weeklyAdsMsgLength > 3 && this.viewMoreAdsLink;
        const weeklyAdsFilterData = weeklyAdsMessages.filter((item) =>
            this.isValidWeeklyAd(item.available_from, item.available_to)
        );

        const weeklyAdsFilterDataLength = weeklyAdsFilterData.length;
        if (!weeklyAdsFilterDataLength) {
            return false;
        }

        if (weeklyAdsFilterDataLength > 3) {
            weeklyAdsData = weeklyAdsFilterData.slice(0, 3);
        } else {
            weeklyAdsData = weeklyAdsFilterData;
        }
        const weeklyAdsList =
            weeklyAdsData.length &&
            weeklyAdsData.map((item) => {
                const validFromInfo = item.valid_from;
                const validToInfo = item.valid_to;
                const validFrom =
                    (validFromInfo && DateFormatter.format('MMM Do', validFromInfo)) || '';
                const validTo = (validToInfo && DateFormatter.format('MMM Do', validToInfo)) || '';
                const displayName = item.external_display_name;
                const weeklyAdImg = item.first_page_thumbnail_400h_url || this.weeklyAdsDefaultImg;
                return (
                    <a
                        href={item.deep_link}
                        className={cx('weeklyAdsPageLink')}
                        onClick={this.weeklyAdClickHandler}
                    >
                        <div className={cx('weeklyAdsTile')}>
                            {weeklyAdImg && (
                                <div className={cx('weeklyAdsImgWrap')}>
                                    <img
                                        src={weeklyAdImg}
                                        className={cx('weeklyAdsImg')}
                                        alt={displayName}
                                    />
                                </div>
                            )}
                            <div className={cx('weeklyAdsInfoWrap')}>
                                {displayName && (
                                    <h4 className={cx('weeklyAdsDisplayName')}>{displayName}</h4>
                                )}
                                {validFrom && validTo && (
                                    <span
                                        className={cx('weeklyAdsTimes')}
                                    >{`Valid ${validFrom} - ${validTo}`}</span>
                                )}
                            </div>
                        </div>
                    </a>
                );
            });
        return (
            <div className={cx('weekyAdsWrap')}>
                <h3 className={cx('weekyAdsTitle')}> Weekly Ads </h3>
                <div className={cx('weeklyAdsListWrap')}>
                    {weeklyAdsList}
                    {viewAllAdsLink && (
                        <div className={cx('viewAllAdsLinkWrap')}>
                            <a href={viewAllAdsLink} className={cx('viewAllAdsLink')}>
                                View All Ads
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    getPreferredStore = () => {
        const {
            featureFlags: { useOldCommonBopisService = false },
            locationServiceStoreInfo = {},
        } = this.props;
        let returnValue = '';
        if (useOldCommonBopisService) {
            returnValue =
                (!isEmpty(this.state.akamaiStoreInfo) && this.state.akamaiStoreInfo) ||
                locationServiceStoreInfo ||
                {};
        } else {
            const userPreferredStoreCookie = Cookies.load(
                locationServiceCookies.userPreferredStore,
                true
            );
            returnValue = !isEmpty(userPreferredStoreCookie) ? locationServiceStoreInfo : {};
        }
        return returnValue;
    };

    /* istanbul ignore next */
    renderHoverStoreTooltipData = () => {
        const {
            storeName,
            street,
            city,
            state,
            zipcode,
            phone,
            timings,
            timingsOverrideMessage,
        } = this.getPreferredStore();
        const {
            featureFlags: { useOldCommonBopisService = false },
            isFragment,
        } = this.props;
        return (
            <div className={cx('storeTooltipWrap')}>
                {
                    <div className={cx('storeDetailInfoWrap')}>
                        <div className={cx('storeDetails')}>
                            {storeName && <span className={cx('storeName')}>{storeName}</span>}
                            <div className={cx('findAStoreLinkWrap')}>
                                {useOldCommonBopisService
                                    ? storeName && (
                                          <a
                                              href={this.findAStoreLink}
                                              className={cx('findAStoreLink')}
                                              onClick={this.moreStoresClickHandler}
                                              automationId="at-more-stores"
                                              id="headerMoreStoresLink"
                                          >
                                              More Stores
                                          </a>
                                      )
                                    : !isFragment && (
                                          <Button
                                              size="Sm"
                                              type="linkbutton"
                                              linkUrl="javascript:void(0)"
                                              buttonType="Link"
                                              className={cx('changeSliderLink')}
                                              onClick={this.triggerStoreSelectionSlider}
                                          >
                                              <span className="text-xsmall">Change</span>
                                          </Button>
                                      )}
                            </div>
                        </div>
                        <div>
                            {
                                <span className={cx('storeAddress')}>
                                    {street && `${street}, `}
                                    {city && `${city}, `}
                                    {state && `${state} `}
                                    {zipcode && `${zipcode} `}
                                </span>
                            }
                            {
                                phone && (
                                    <span className={cx('storePhone')} x-ms-format-detection="none">
                                        {phone}
                                    </span>
                                ) // x-ms-format-detection is to overide phone no. property on IE
                            }
                            {useOldCommonBopisService && !storeName && (
                                <div className={cx('fallBackFasLinkWrap')}>
                                    <a
                                        href={this.findAStoreLink}
                                        className={cx('fallBackFasLink')}
                                        onClick={this.findAStoreClickHandler}
                                        id="headerFindAStoreLink"
                                    >
                                        Find A Store
                                    </a>
                                </div>
                            )}
                            {!timingsOverrideMessage ? (
                                <div className={cx('storeTimeWrap')}>
                                    <List
                                        direction={configForList.direction.VERTICAL}
                                        spacing={configForList.spacing.NONE}
                                        itemSpacing={configForList.spacing.NONE}
                                        datasource={timings}
                                        childRenderer={this.storeTimingsRenderer}
                                        listBodyClass={cx('storeTime')}
                                        listStyleClass={cx('ulStoreTimeWrap')}
                                    />
                                </div>
                            ) : (
                                !useOldCommonBopisService && (
                                    <div className={cx('timingsOverrideMessage')}>
                                        {timingsOverrideMessage}
                                    </div>
                                )
                            )}
                            <div className={cx('deliveryInfoWrap')}>
                                {timingsOverrideMessage && !this.displaySDPU && this.storeInfo && (
                                    <span className={cx('storeCloseInfo')}>{this.storeInfo}</span>
                                )}
                                {this.displaySDPU && (
                                    <div>
                                        <a
                                            href={this.sameDayPickupLink}
                                            className={cx('deliveryInfoLink')}
                                        >
                                            <div className={cx('deliveryDetails')}>
                                                <Icon
                                                    automationId="at-icon-store-fast-truck"
                                                    iconType="svg"
                                                    width="63px"
                                                    height="36px"
                                                    viewBox="0 0 63 36"
                                                    className={cx('store-fast-truck')}
                                                >
                                                    <StoreFastTruck />
                                                </Icon>
                                                <p className={cx('sdpuInfoWrap')}>
                                                    <span className={cx('sdpuInfo')}>
                                                        Order before <b>3pm</b> to get
                                                    </span>
                                                    <b>
                                                        <span className={cx('sdpuFreeText')}>
                                                            FREE
                                                        </span>
                                                        same day pickup
                                                    </b>
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                }
                {this.displayWeeklyAds()}
            </div>
        );
    };

    analyticsForNavigationClick(localTitle) {
        this.props.actions.triggerNavigationClick({
            linkName: localTitle,
            isReload: false,
        });
    }

    moreStoresClickHandler = () => this.analyticsForNavigationClick('top:findastore:morestores');

    weeklyAdClickHandler = () => this.analyticsForNavigationClick('top:weekly ad');

    /* istanbul ignore next */
    findAStoreClickHandler = () => {
        this.analyticsForNavigationClick('top:findastore');
        window.location.href = this.findAStoreLink;
    };

    isGalleryPage = (pageUrl = '') => {
        const validGalleryRoutes = ['/s?', '/g/'];
        return validGalleryRoutes.some((route) => pageUrl.includes(route));
    };

    isCart = (pageUrl = '') => pageUrl.includes('/cart');

    onSliderSelectStore = (sliderCallBack = {}) => {
        const {
            actions,
            pdpProductOffering = {},
            checkoutProps: { findStores: { selectActionCallback } = {} } = {},
        } = this.props;
        const pageUrl = window && window.location.href;

        /* istanbul ignore next */
        if (this.isCart(pageUrl)) {
            actions.selectStore({ ...sliderCallBack, selectActionCallback });
        }

        /* istanbul ignore next */
        if (pageUrl && this.isGalleryPage(pageUrl)) {
            const isSDPUEnabled = Utils.getURLParameterBykey('store_availability', pageUrl);
            if (isSDPUEnabled) {
                const { id = '' } = sliderCallBack.storeDetails || {};
                window.location.href = Utils.updateQueryStringParameter(pageUrl, 'storeIds', id);
            }
        }
        /* istanbul ignore else */
        if (pdpProductOffering.actualSkuId) {
            actions.selectStore({ ...sliderCallBack, fromMiniPDP: false });
        }
        const keyValue = SessionStorage.getData('setBopisDefaultStore', true);
        /* istanbul ignore if */
        if (isEmpty(keyValue)) {
            actions.triggerBopisDefaultStoreChange();
            SessionStorage.setData('setBopisDefaultStore', true, true);
        } else actions.triggerBopisPickupStoreChange();
    };

    triggerStoreSelectionSlider = (e) => {
        e && e.stopPropagation && e.stopPropagation();
        const {
            useOldCommonBopisService = false,
            actions,
            preferences: { defaultRadius = 25 },
            pdpProductOffering,
            findStoresDetails,
        } = this.props;
        const { inputZipCode = '' } = this.getPreferredStore();
        let searchZip = '';
        if (inputZipCode) {
            searchZip = inputZipCode;
        } else {
            searchZip = _get(findStoresDetails, 'zipCode', '');
        }
        /* istanbul ignore next */
        if (searchZip) {
            const payload = {
                zipCode: searchZip,
                miles: defaultRadius,
                pageSize: findStores.pageSize, // number of stores to request per request
                showAvailable: !!useOldCommonBopisService,
                skus: pdpProductOffering.actualSkuId ? pdpProductOffering.actualSkuId : '',
            };
            actions.findStores(payload);
        }
        !useOldCommonBopisService &&
            actions.setFindStoreSliderProps({
                findStoresAction: actions.findStores,
                enableSlimFindStores: true,
                enableProductCardImage: true,
                hideContentScroll: true,
                isMounted: actions.openSlidePanel,
                selectStoreAction: this.onSliderSelectStore,
                skuSelected: pdpProductOffering.actualSkuId ? pdpProductOffering.actualSkuId : '',
            });
        actions.openSlidePanel();
    };

    /**
     * On store hover, Geo located store information will be displayed.
     */
    renderStoreInfo = () => {
        const {
            featureFlags: { enableHeaderStoreMenuSlider = false, useOldCommonBopisService = false },
            isFragment,
        } = this.props;
        const { storeName, city, state } = this.getPreferredStore();
        return enableHeaderStoreMenuSlider ? (
            <>
                <YodaTooltipLazy
                    tooltipContentClass={cx('storeTooltipContent', {
                        storeIconWithNameTooltip: !useOldCommonBopisService,
                    })}
                    tooltipTextClass={cx('storeHoverTooltip', {
                        'new-store-service-block': !useOldCommonBopisService,
                    })}
                    renderTooltipContents={this.renderHoverStoreTooltipData()}
                    triggerEventName={
                        useOldCommonBopisService || (!useOldCommonBopisService && storeName)
                            ? 'mouseover'
                            : ''
                    }
                    tooltipBodyClassName={cx('storeContainer')}
                    stayOnContentHover
                    callBackFun={this.toggleHoverStores}
                    shouldToggleOnMouseOver
                    tooltipType="link"
                >
                    <div
                        className={cx('svg-icon', 'ctaList', 'storeBlock')}
                        data-automation-id="header_store_block"
                        onClick={this.findAStoreClickHandler}
                    >
                        <YDTIcon
                            width={!useOldCommonBopisService ? '48px' : '40px'}
                            height={!useOldCommonBopisService ? '48px' : '40px'}
                        >
                            <StoreLine />
                        </YDTIcon>
                        {/* iconText to be hidden when flag is false in order to capture activity map */}
                        {
                            <h4 className={cx('menuText', { iconText: !useOldCommonBopisService })}>
                                Stores
                            </h4>
                        }
                    </div>
                    {
                        /* Displaying store name on header was implemented
                        as a part of enabling User Preffered Store On Header Story */
                        !useOldCommonBopisService ? (
                            <div>
                                <Button
                                    size="Sm"
                                    type="linkbutton"
                                    linkUrl="javascript:void(0)"
                                    buttonType="Text"
                                    className={cx('storeNameBlock')}
                                    onClick={this.findAStoreClickHandler}
                                >
                                    <div className={cx('storeNameOnHeader')}>
                                        {storeName || headerStore.NO_STORE_LOCATED}
                                    </div>
                                    {city || state ? (
                                        <span className={cx('storeAddress')}>
                                            {city && `${city}`}
                                            {city && state && `, `}
                                            {state && `${state}`}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </Button>
                                {!isFragment && isEmpty(storeName) ? (
                                    <Button
                                        size="Sm"
                                        type="linkbutton"
                                        linkUrl="javascript:void(0)"
                                        buttonType="Link"
                                        className={cx('storeInformationTxt')}
                                        onClick={this.triggerStoreSelectionSlider}
                                    >
                                        <span className="text-xsmall">
                                            {findStores.selectAStoreHeaderText}
                                        </span>
                                    </Button>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : null
                    }
                </YodaTooltipLazy>
            </>
        ) : (
            <div
                className={cx('svg-icon', 'ctaList', 'storeBlock')}
                data-automation-id="header_store_block"
            >
                <Icon
                    iconType="svg"
                    className={cx('svg-icon')}
                    width="40px"
                    height="40px"
                    viewBox="0 0 40 40"
                    pathClassName={cx('findStoreFillColor')}
                >
                    <StoreLine />
                </Icon>
                <h4 className={cx('menuText')}>Stores</h4>
            </div>
        );
    };

    renderAccount = () => {
        const styleTooltip = this.state.showLoader
            ? cx('tooltipMenuWrapper', 'tooltipWithLoader')
            : cx('tooltipMenuWrapper');

        // todo we have to revisit the approach. There way when we have 5 small components lazy loaded right after the page loaded is not proper way
        // What i see here is that we have 3 components that should not be part of app.js at all for mobile and should work for desktop only. What im thinking that we need to have 2 app.js entries:
        //
        //     app.mobile.js
        // app.desktop.js
        //
        // and using DefinePlugin just create different bundles.
        //
        //     after that we would load on client only Html.jsx with needed app.mobile.js or app.desktop.js file.
        //
        //     [~prajappa][~vvozniak][~iborovts] need your input here. What do you think?

        const getAccountDetails = () => (
            <div
                className={styles.accountMenu}
                data-automation-id="account-tooltip"
                ref={(node) => {
                    this.wrapperRef = node;
                }}
            >
                {this.renderAccoundInformation()}
            </div>
        );
        let item = null;
        if (__SERVER__) {
            item = getAccountDetails();
        } else {
            item = this.props.headerLoaded && (
                <ThrottleFeatureRender
                    featurePath="enableHeaderAccountMenuSlider"
                    headerName="X-HEADER-ACCOUNT-MENU-SLIDER"
                    cookieName="DP_HEADER_ACCOUNT_MENU_SLIDER"
                >
                    {(isEnabled) => (
                        <>
                            {isEnabled && (
                                // Div is for IE11 changes for event bubbling
                                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                                <div onClick={this.headerAccountMenuClickHandler}>
                                    {getAccountDetails()}
                                </div>
                            )}
                            {!isEnabled && (
                                <YodaTooltipLazy
                                    tooltipContentClass={styleTooltip}
                                    tooltipBodyClassName={cx('headerTooltipWrapper')}
                                    renderTooltipContents={this.renderTooltipData()}
                                    triggerEventName="click"
                                    direction="Bottomright"
                                    tooltipPlacement="Right"
                                >
                                    {getAccountDetails()}
                                </YodaTooltipLazy>
                            )}
                        </>
                    )}
                </ThrottleFeatureRender>
            );
        }
        return item;
    };

    renderHamburger = () => {
        /* istanbul ignore next */
        const {
            featureFlags: { enableHamburgerMenuLabel = false, enableRenderBotDept = false } = {},
            deviceType: { isDesktop, isBot = false },
            pageName = 'HOME',
            checkoutProps,
        } = this.props;
        const botHamburger =
            isBot && enableRenderBotDept ? (
                <MobileBotHamburger pageName={pageName} />
            ) : (
                <HamburgerPlaceHolder
                    headerOverlayRef={this.headerOverlayRef}
                    enableHamburgerMenuLabel={enableHamburgerMenuLabel}
                    isBot={isBot}
                    enableRenderBotDept={enableRenderBotDept}
                    checkoutProps={checkoutProps}
                    HamburgerSlider={this.props.HamburgerSlider}
                    displayHamburgerSlider={this.props.actions.displayHamburgerSlider}
                />
            );
        return !isDesktop ? botHamburger : null;
    };

    renderStickyTimer() {
        let stickyTimerHtml = false;
        /* Cart has requirement not to show sticky timer if special offers enabled */
        if (this.props.disableStickyTimerOnCart) {
            return null;
        }
        /* istanbul ignore next */
        if (Utils.detectisIE()) {
            stickyTimerHtml = this.props.featureFlags.enableStickyTimer &&
                this.props.featureFlags.enableStickyTimerForIE && (
                    <StickyTimer renderFromHeader mountOnServer />
                );
        } else {
            stickyTimerHtml = this.props.featureFlags.enableStickyTimer && (
                <StickyTimer renderFromHeader mountOnServer />
            );
        }
        return stickyTimerHtml;
    }

    setGeoZipCode() {
        /* istanbul ignore next */
        const { featureFlags = {} } = this.props;
        if (featureFlags.enableAkamaiGeoZipCode) {
            this.props.actions.setAkamaiGeoZipcode();
        }
    }

    getStoreDetails(shouldRefreshStore = false) {
        /* istanbul ignore next */
        const { featureFlags = {} } = this.props;
        if (featureFlags.enableLocationService) {
            this.props.actions.loadUserStoreLocationInfo(shouldRefreshStore);
        }
    }

    /* istanbul ignore next */
    validateHomePage = () => {
        if (!__SERVER__) {
            return window.location.pathname === '/';
        }
        return false;
    };

    // For VisNav Integration
    /* istanbul ignore next */
    visNavRender = (dataItem) => {
        const { title, image, links, openInNewTab } = dataItem;
        return (
            <div className={cx('headerVisualNavComponent')}>
                <a
                    className={cx('visualNavLink')}
                    href={links}
                    aria-label={title}
                    data-link-href={links}
                    target={openInNewTab ? '_blank' : '_self'}
                    rel="noreferrer"
                    // onClick={() => this.handleClickVisualNavItemLink(dataItem)}
                >
                    {image && (
                        <div className={cx('imgBlock')}>
                            <img
                                className={cx('vizNavImage')}
                                src={image}
                                alt={title}
                                title={title}
                            />
                        </div>
                    )}
                    <div className={cx('title')}>{title}</div>
                </a>
            </div>
        );
    };
    // For Vis nav integration Ends

    // hpan Ends
    render() {
        /* istanbul ignore next */
        const {
            shouldRender,
            deviceType,
            featureFlags = {},
            headerConfigs = {},
            showOverlay,
            showBgWhite,
            inlineOverlay,
            activeCartConfig,
            toggleWiggleCart,
        } = this.props;
        const {
            hideAccountSection = false,
            // hideRewardsSection = false, /* commenting as per new Header Design */
            // hideTrackMyOrder = false, /* commenting as per new Header Design */
            hideStoresBlock = false,
        } = headerConfigs.flags || {};
        /* istanbul ignore if */
        if (!shouldRender) {
            return this.renderStickyTimer();
        }
        const {
            isDesktop = false,
            isMobile,
            isTablet,
            isBot,
        } = this.props.deviceType; /* commenting as per new Header Design */
        /* istanbul ignore next */
        const disableTopMini =
            featureFlags.disableAccessViewFromHeader && !featureFlags.promoBanner;
        const enableExitPosClient = !__SERVER__ && featureFlags.enableExitPos;
        const enableActiveCart =
            !__SERVER__ && featureFlags.enableActiveCartReminder && !isEmpty(activeCartConfig);
        /* istanbul ignore next */
        const cartIcon = this.state.cartCount > 99 ? 'cart-large' : 'cart-line';
        const cartIconComponent = this.state.cartCount > 99 ? <CartLarge /> : <CartLine />;
        const cartStyleName = cx('bagBlock', 'ctaList', 'cartBag');
        /* istanbul ignore next */
        const flyoutMenuClass = featureFlags.enableFlyoutMenu ? 'flyoutMenu' : 'secondaryMenu';
        const flyoutMenuDeviceClass = isDesktop ? 'menuDesktop' : 'menuNotDesktop';
        const headerDesktopClass = isDesktop ? 'headerDesktop' : 'headerNotDesktop';
        /* istanbul ignore next */
        const headerTabletClass = isTablet ? 'headerTablet' : 'headerNotTablet';
        const headerMobileClass = isMobile ? 'headerMobile' : 'hederNotMobile';
        const headerBotClass = isBot ? 'headerBot' : 'headerNotBot';
        const { hideVisNavSlider = true } = featureFlags;
        /* istanbul ignore next */
        const newSiteHeightClass = !featureFlags.promoBanner ? 'noHeight' : '';
        const disableStickyHeaderClass = featureFlags.disableStickyHeader
            ? 'disableStickyHeader'
            : '';
        /* istanbul ignore next */
        const bgWhite = showBgWhite ? cx('makeBgWhite') : cx('');
        return (
            <>
                {/* render Chat button as hidden and ensighten  witll pick dom and do further processing */}
                {!this.props.isFragment && <ThirdPartyServiceButton name="chat" />}
                {/* For syndicate site
                    TODO: #TJ evaluate removing the one in <Layout/> */}
                {
                    /* istanbul ignore next */
                    inlineOverlay && showOverlay && (
                        <div className={cx('inlineOverlay', this.props.menuOverlayClass || '')} />
                    )
                }
                <div className={cx('headerOverlay')} ref={this.headerOverlayRef} />
                {/* Header Primary */}
                <div className={cx('primaryHeader')} id="primaryHeader">
                    {!disableTopMini && (
                        <TopMiniNav
                            deviceType={this.props.deviceType}
                            isNewHeader
                            enableSitePromo={featureFlags.promoBanner}
                            disableAccessViewFromHeader={featureFlags.disableAccessViewFromHeader}
                        />
                    )}
                </div>
                {/* Header Primary Ends */}
                <header
                    data-automation-id="headerBlock"
                    id={this.props.headerId || 'header'} // for analytics activity map
                    className={cx(
                        'headerBlock',
                        'newHeader',
                        headerMobileClass,
                        headerTabletClass,
                        headerDesktopClass,
                        headerBotClass,
                        this.state.headerScroll,
                        this.getHeaderTheme(),
                        disableStickyHeaderClass,
                        bgWhite
                    )}
                >
                    <div
                        data-automation-id="mainHeaderBlock"
                        className={cx(
                            'mainHeaderBlock',
                            this.props.productSearchFocus,
                            newSiteHeightClass
                        )}
                    >
                        <FetchRegion />
                        {/* Header Secondary */}
                        <div
                            data-automation-id="headerMainBlock"
                            className={cx('mainMenu', this.props.headerMainClass || '')}
                        >
                            <ul className={cx('headerBlockList', 'containerWidth')}>
                                {/* iconTextWrapper class will have to inject only if the menu feature flag enabled */}
                                <li
                                    className={cx(
                                        'headerList',
                                        'menuBlock',
                                        featureFlags.enableHamburgerMenuLabel
                                            ? 'iconTextWrapper'
                                            : ''
                                    )}
                                >
                                    <div
                                        id="hamburgerBlock"
                                        data-automation-id="hamburgerBlock"
                                        className={styles.headerNavigation}
                                    >
                                        {this.renderHamburger()}
                                    </div>
                                </li>
                                {/* logoCenter class will have to inject only if the menu feature flag enabled */}
                                <li
                                    id="logoBlock"
                                    data-automation-id="logoBlock"
                                    className={cx('headerList', 'logoBlock')}
                                >
                                    <div className={cx('logoMainBlock')}>{this.getLogo()}</div>
                                    {!isDesktop && (
                                        <div
                                            id="mobSearchIcon"
                                            data-automation-id="mobSearchIcon"
                                            className={cx(
                                                'mobSearchIcon',
                                                this.props.productSearchFocus
                                            )}
                                        />
                                    )}
                                </li>
                                <li
                                    id="searchBlock"
                                    data-automation-id="searchBlock"
                                    className={cx(
                                        'headerList',
                                        'searchBlock',
                                        this.props.searchClass || '',
                                        this.props.productSearchFocus
                                    )}
                                >
                                    <ProductSearch
                                        headerOverlayRef={this.headerOverlayRef}
                                        searchSelectAnimationRemove={
                                            this.searchSelectAnimationRemove
                                        }
                                        automationId="tablet-search-block"
                                        productSearchContainerCustomClass={cx(
                                            'headerSearchContainerCustomClass'
                                        )}
                                        productSearchIconCustomClass={cx(
                                            'headerSearchIconCustomClass'
                                        )}
                                        productSearchInputCustomClass={cx(
                                            'headerSearchInputCustomClass'
                                        )}
                                        productResetIconCustomClass={cx(
                                            'headerResetIconCustomClass'
                                        )}
                                    />
                                </li>
                                {/* No Border 'noRgtBorder' only if the hamburger menu feature flag enabled */}
                                <li
                                    id="ctaBlock"
                                    data-automation-id="ctaBlock"
                                    className={cx('headerList', 'ctaBlock', 'right')}
                                >
                                    {/* {!hideRewardsSection ? <div className={cx('svg-icon', 'ctaList', this.props.rewardsClass || '', 'rewardsBlock', (featureFlags.enableHamburgerMenuLabel ? 'noRgtBorder' : ''))}>
                                        {this.getRewardsIcon()}
                                    </div> : ''} */}
                                    {/* No Border 'noRgtBorder' only if the hamburger menu feature flag enabled */}
                                    {/* {!hideAccountSection ? <div className={cx('accBlock', 'ctaList', (featureFlags.enableHamburgerMenuLabel ? 'noRgtBorder' : ''))}>
                                        {this.renderAccount()}
                                    </div> : '' } */}
                                    {/* {(isDesktop && !hideTrackMyOrder) ? (
                                        <div className={cx('ctaList', this.props.trackOrderClass || '', 'trackMyOrderBlock')}>
                                            {this.getTrackMyOrder()}
                                        </div>
                                    ) : ''} */}
                                    {/* Have to do the changes as per Functionality */}
                                    {/* Stores Block Need to put condition for Mobile to Hide */}
                                    {!hideStoresBlock && isDesktop ? (
                                        <div
                                            id="findStore"
                                            data-automation-id="findStoreBlock"
                                            className={cx('svg-icon', 'ctaList', 'findStoreBlock')}
                                        >
                                            {this.renderStoreInfo()}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {/* Stores Block Ends Need to put condition for Mobile to Hide */}
                                    {/* Account Block Need to put condition for Mobile to Hide */}
                                    {!hideAccountSection && isDesktop ? (
                                        <div
                                            id="accountBlock"
                                            data-automation-id="accountBlock"
                                            className={cx(
                                                'accBlock',
                                                'ctaList',
                                                featureFlags.enableHamburgerMenuLabel
                                                    ? 'noRgtBorder'
                                                    : ''
                                            )}
                                            ref={(node) => {
                                                this.accountIcon = node;
                                            }}
                                        >
                                            {this.renderAccount()}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {/* Account Block Ends Need to put condition for Mobile to Hide */}
                                    {/* Have to do the changes as per Functionality Ends */}
                                    <CartWrapper
                                        cartStyleName={cartStyleName}
                                        enableActiveCart={enableActiveCart}
                                        activeCartConfig={activeCartConfig}
                                        toggleWiggleCart={toggleWiggleCart}
                                    >
                                        <Link
                                            href={this.getCartLink()}
                                            className={cx('headerIcon', 'bagIcon')}
                                            data-automation-id="bagLink"
                                            title="my cart"
                                            aria-label={`Bag ${this.state.cartCount} - items`}
                                            rel="noopener noreferrer"
                                        >
                                            <div className={cx('svg-icon')}>
                                                <Icon
                                                    iconType="svg"
                                                    className={cx('svg-icon')}
                                                    width="40px"
                                                    height="40px"
                                                    viewBox="0 0 40 40"
                                                    pathClassName={cx('cartFillColor')}
                                                >
                                                    {cartIconComponent}
                                                </Icon>
                                            </div>
                                            {isDesktop && <h4 className={cx('menuText')}>Cart</h4>}
                                            {this.state.cartCount > 0 ? (
                                                <span
                                                    id="orderQuantity"
                                                    data-automation-id="item-bag-count"
                                                    className={styles.cartCount}
                                                >
                                                    {this.state.cartCount}
                                                </span>
                                            ) : null}
                                        </Link>
                                    </CartWrapper>
                                    {
                                        /* istanbul ignore next */
                                        enableExitPosClient &&
                                        (Cookies.load('x-mode') ||
                                            Cookies.load('Fusion-Platform')) ? (
                                            <div className={cx('ctaList')}>
                                                <ExitPosLazy />
                                            </div>
                                        ) : (
                                            ''
                                        )
                                    }
                                </li>
                            </ul>
                        </div>
                        {/* Header Secondary Ends */}
                        <div
                            id="flyoutMenuBlock"
                            data-automation-id="flyoutMenuBlock"
                            className={cx(
                                'menuBlock',
                                this.props.productSearchFocus,
                                flyoutMenuDeviceClass,
                                flyoutMenuClass
                            )}
                        >
                            {/* For Flyout menu */}
                            {this.props.deviceType.isDesktop && (
                                <SecondaryNavigationPanel
                                    deviceType={deviceType}
                                    singleFlyoutSyndicateExperience={!!inlineOverlay}
                                />
                            )}
                            {/* For Flyout menu ends */}
                        </div>
                    </div>
                </header>
                <div
                    id="timerVisNavBlock"
                    data-automation-id="timerVisNavBlock"
                    className={cx('timerVisNavBlock')}
                >
                    {/* Placeholder for VisNavBlock */}
                    {
                        /* istanbul ignore next */
                        !this.props.deviceType.isDesktop &&
                            !isEmpty(this.props.hambergurMenu) &&
                            this.validateHomePage() &&
                            !hideVisNavSlider && (
                                <List
                                    datasource={this.props.hambergurMenu}
                                    childRenderer={this.visNavRender}
                                    automationId="render-item-content"
                                    spacing="None"
                                    listMainCustomClass={cx('renderListMainCustomClass')}
                                    listStyleClass={cx('renderListStyle')}
                                    listBodyClass={cx('renderListBody')}
                                    itemStyleClass={cx('renderItemStyle')}
                                    direction="Horizontal"
                                />
                            )
                    }
                    {/* Placeholder for VisNavBlock Ends */}
                    {this.renderStickyTimer()}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { context } = state;
    const deviceType = context && context.deviceType ? context.deviceType : {};
    const preferences = context && context.preferences ? context.preferences : {};
    /* istanbul ignore next */
    const primaryLinks = preferences && preferences.primaryLinks ? preferences.primaryLinks : {};
    const desktopAccountMenuList = _get(context, 'preferences.desktop.hamburger', {});
    const featureFlags = _get(context, 'featureFlags', {});
    const showWelcomeToolTip =
        state.signInSliderDetails && state.signInSliderDetails.showWelcomeToolTip;
    const headerConfigs = preferences && preferences.headerConfigs;
    const activeCartConfig = _get(state.context, 'preferences.activeCartReminderConfig', {});
    /* istanbul ignore next */
    const disableStickyTimerOnCart =
        _get(state, 'context.featureFlags.enableSpecialOffers', false) && deviceType.isMobile;
    const isFragment = _get(state.context, 'isFragment', false);

    return {
        signedOut: state.session && state.session.signedOut,
        deviceType,
        preferences,
        headerConfigs,
        bagItemCount: state.bagItemCount,
        primaryLinks: deviceType.isDesktop ? primaryLinks.desktop : primaryLinks.device,
        accountMenuList: preferences.hamburger || {},
        desktopAccountMenuList,
        accounts: state.accounts || {
            userProfile: {
                firstName: null,
                accountId: null,
                rewardsStatus: null,
                userState: null,
                totalCerts: null,
            },
        },
        featureFlags,
        showWelcomeToolTip,
        headerLoaded: selectLazy(state)[headerLoad],
        showOverlay: state.showOverlay,
        shouldRender: selectShouldRender(state),
        activeCartConfig,
        toggleWiggleCart: state.toggleWiggleCart,
        disableStickyTimerOnCart,
        enableKeepMeLoggedIn: selectKeepMeLoggedInThrottleFF(state),
        productSearchFocus: state.productSearchFocus,
        hambergurMenu: fetchVizNavIrisDepartmentData(state.irishambergurMenu),
        locationServiceStoreInfo: state.locationServiceReducer,
        weeklyAdsMessages: state.weeklyAdsMessages,
        showBgWhite: state.showBgWhite,
        galleryRerender: _get(state, 'rerender'),
        isFragment,
        pdpProductOffering: state.productOffering,
        findStoresDetails: state.findStoresDetails,
        HamburgerSlider: state.HamburgerSlider,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        Object.assign(
            analyticsActions,
            orderAction,
            itemCountAction,
            storeActions,
            storeNavigationActions,
            HamburgerAction,
            LocationAction,
            vendorAction,
            WeeklyAdsAction,
            KeepMeLoggedInAction,
            FindStoresAction,
            {
                openSignInSlider,
                getUserDetails,
                accessTimerStart,
                accessTimerAuthCheck,
                showLazy,
                showLogoutTooltip,
                openAccountMenuPage,
                loadUserStoreLocationInfo,
                updateUserStoreLocationInfo,
                productSearchFocusAction,
                customStepUp,
                updateStoreOnCartAction,
            },
            GalleryRerenderAction
        ),
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(YodaHeader);
